import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './Footer.module.css';
import logoVector from './images/Logo.svg';
import IconFacebook from '../../../shared/ui/icons/IconFacebook';
import IconLinkedin from '../../../shared/ui/icons/IconLinkedin';
import IconX from '../../../shared/ui/icons/IconX';
import IconInstagram2 from '../../../shared/ui/icons/IconInstagram2';
import IconLogo from '../../../shared/ui/icons/IconLogo';
const Footer: React.FC = () => {
    const navigate = useNavigate();

    return (
        <footer className={styles.footer}>
            <div className={styles.topRow}>
                <div className={styles.logoBox} onClick={() => navigate('/')}>
                    <IconLogo color="#7545ED" textColor="#fff" />
                    <h2 className={styles.logoText}>SimpleeCreate</h2>
                </div>
                <div className={styles.socialRow}>
                    <a
                        href="https://www.facebook.com/simpleecreate"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <IconFacebook />
                    </a>
                    <a
                        href="https://www.instagram.com/simpleecreate"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <IconInstagram2 />
                    </a>
                    <a
                        href="https://www.linkedin.com/company/simpleecreate"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <IconLinkedin />
                    </a>
                    {/* <a href="https://x.com/simpleecreate" target="_blank" rel="noopener noreferrer">
                        <IconX />
                    </a> */}
                </div>
            </div>

            <hr className={styles.divider} />

            <div className={styles.bottomRow}>
                <p className={styles.copy}>© 2025 SimpleeCreate. All rights reserved</p>
                <nav className={styles.links}>
                    <Link to="/">Home</Link>
                    <Link to="/login">Login</Link>
                    {/* <Link to="/affiliate">Affiliates</Link> */}
                    <Link to="/contact">Contact Us</Link>
                    <Link to="/pricing">Pricing</Link>
                    <span onClick={() => navigate('/terms-of-use')}>Terms of Use</span>
                    <span onClick={() => navigate('/privacy-policy')}>Privacy Policy</span>
                    <span onClick={() => navigate('/eula')}>EULA</span>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
